import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import SignInPage from 'pages/sign-in';
import ResetPasswordPage from 'pages/reset-password';
import CreateNewPasswordPage from 'pages/create-new-password';
import CreateActivity from 'pages/create-activity';
import CreateAccommodation from 'pages/create-accommodation';
import AccommodationsAndActivitiesPage from 'pages/accommodations-and-activities';
import BookActivitiesList from 'pages/book-activities-list/BookActivitiesList';
import BookActivity from 'pages/book-activity/BookActivity';
import ManualBookActivity from 'pages/book-activity-manual/ManualBookActivity';
import BookAccommodationList from 'pages/book-accommodations-list/BookAccommodationsList';
import BookingList from 'pages/bookings-list';
import BookAccommodation from 'pages/book-accommodation/BookAccommodation';
import ManualBookAccommodation from 'pages/book-accommodation-manual/ManualBookAccommodation';
import Statistics from 'pages/statistics/Statistics';
import SettingsPage from 'pages/user-settings/SettingsPage';
import ActivitiesOverviewCalendar from 'pages/overview-calendar/ActivitiesOverviewCalendar';
import AccommodationsOverviewCalendar from 'pages/overview-calendar/AccommodationsOverviewCalendar';
import Overview from 'pages/overview/Overview';
import WidgetSettings from './pages/widget-settings/WidgetSettings';
import BusinessOwners from './pages/business-owners/BusinessOwners';
import Users from './pages/users/Users';
import TestWidget from 'pages/test-widget/TestWidget';
import StripeInstruction from 'pages/payments-instruction/StripeInstruction';
import PayPalInstruction from 'pages/payments-instruction/PayPalInstruction';
import BookingDetails from 'pages/booking-details/BookingDetails';
import RatePlan from 'pages/rate-plan/RatePlan';
import ActivityRatePlan from 'pages/rate-plan/activity-rate-plan/ActivityRatePlan';

import CreateRentalItems from 'pages/create-rental-items/CreateRentalItems';

import BookRentalItemsList from 'pages/book-rental-items-list/bookRentalItems';
import BookRentalItems from 'pages/book-rental-items/BookRentalitems';
import BookingRentalItemsList from 'pages/booking-rental-items-list/BookingRentalItemsList'
import RentalInvoice from 'pages/rental-items-invoice/RentalInvoice '

import {
  PrivateRoute,
  AuthLayout,
  UpdateActivityWrapper,
  UpdateAccommodationWrapper,
  UpdateAccommodationBookingWrapper,
  UpdateActivityBookingWrapper,
  UpdateRentalItemsWrapper,
  UpdateRentalItemsBookingWrapper
} from 'components';

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/login">
          <AuthLayout>
            <SignInPage />
          </AuthLayout>
        </Route>

        <Route path="/password/reset">
          <AuthLayout>
            <ResetPasswordPage />
          </AuthLayout>
        </Route>

        <Route path="/password/reset-new/:id/:token">
          <AuthLayout>
            <CreateNewPasswordPage isConfirm={false} isReset={true} />
          </AuthLayout>
        </Route>

        <Route path="/password/confirm-new/:id/:token">
          <AuthLayout>
            <CreateNewPasswordPage isConfirm={true} isReset={false} />
          </AuthLayout>
        </Route>

        <PrivateRoute
          path="/accommodations-bookings/:id/edit"
          component={UpdateAccommodationBookingWrapper}
        />

        <PrivateRoute
          path="/activities-bookings/:id/edit"
          component={UpdateActivityBookingWrapper}
        />

        <PrivateRoute exact path="/activities" component={BookActivitiesList} />

        <PrivateRoute path="/activities/:id/book" component={BookActivity} />

        <PrivateRoute
          path="/activities/:id/manual-book"
          component={ManualBookActivity}
        />

        <PrivateRoute path="/activities/create" component={CreateActivity} />

        <PrivateRoute
          path="/activities/:id/copy"
          component={UpdateActivityWrapper}
        >
          <CreateActivity />
        </PrivateRoute>

        <PrivateRoute path="/activities/:id" component={UpdateActivityWrapper}>
          <CreateActivity />
        </PrivateRoute>

        <PrivateRoute
          exact
          path="/accommodations"
          component={BookAccommodationList}
        />

        <PrivateRoute
          path="/accommodations/:id/book"
          component={BookAccommodation}
        />

        <PrivateRoute
          path="/accommodations/:id/manual-book"
          component={ManualBookAccommodation}
        />

        <PrivateRoute
          path="/accommodations/create"
          component={CreateAccommodation}
        />

        <PrivateRoute
          path="/accommodations/:id/copy"
          component={UpdateAccommodationWrapper}
        >
          <CreateAccommodation />
        </PrivateRoute>

        <PrivateRoute
          path="/accommodations/:id"
          component={UpdateAccommodationWrapper}
        >
          <CreateAccommodation />
        </PrivateRoute>

        <PrivateRoute
          path="/accommodations-and-activities"
          component={AccommodationsAndActivitiesPage}
        />

        <PrivateRoute
          path="/activities-overview-calendar"
          component={ActivitiesOverviewCalendar}
        />

        <PrivateRoute
          path="/accommodations-overview-calendar"
          component={AccommodationsOverviewCalendar}
        />

        <PrivateRoute exact path="/" component={Overview} />
        <PrivateRoute path="/accommodations-and-activities">
          <AccommodationsAndActivitiesPage />
        </PrivateRoute>

        <PrivateRoute
          path="/rental-items/create"
          component={CreateRentalItems}
        />

        <PrivateRoute
          path="/rental-items/:id/book"
          component={BookRentalItems}
        />
        
        <PrivateRoute
          path="/rental-items-bookings/:id/edit"
          component={UpdateRentalItemsBookingWrapper}
        />
       

        <PrivateRoute
          path="/rental-items/:id"
          component={UpdateRentalItemsWrapper}
        >
          <CreateRentalItems />
        </PrivateRoute>

        <PrivateRoute exact path="/rental-items" component={BookRentalItemsList} />

        <PrivateRoute path="/bookings-list" component={BookingList} />
        
         <PrivateRoute path="/bookings-rental-items-list" component={BookingRentalItemsList} />

        <PrivateRoute exact path="/statistics" component={Statistics} />
        <PrivateRoute exact path="/settings" component={SettingsPage} />
        <PrivateRoute path="/widget-settings" component={WidgetSettings} />

        <PrivateRoute path="/business-owners" component={BusinessOwners} />
        <PrivateRoute path="/users" component={Users} />

        <PrivateRoute path="/rate-plan" component={RatePlan} />
        <PrivateRoute path="/activity-rate-plan" component={ActivityRatePlan }/>

        <PrivateRoute path="/test-widget" component={TestWidget} />

        <PrivateRoute
          path="/accommodations-bookings/:id/details/:token"
          component={BookingDetails}
        />
        <PrivateRoute
          path="/activities-bookings/:id/details/:token"
          component={BookingDetails}
        />
        <PrivateRoute
          path="/rental-items-bookings/:id/details/:token"
          component={RentalInvoice}
        />
        <PrivateRoute
          path="/cancel-activity-booking/:id/:token"
          component={BookingDetails}
        />
        <PrivateRoute
          path="/cancel-accommodation-booking/:id/:token"
          component={BookingDetails}
        />

        <PrivateRoute
          path="/cancel-rental_items-booking/:id/:token"
          component={RentalInvoice}
        />

        <PrivateRoute
          path="/stripe-instruction"
          component={StripeInstruction}
        />
        <PrivateRoute
          path="/paypal-instruction"
          component={PayPalInstruction}
        />
      </Switch>
    </Router>
  );
}
